.page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-4);
}

/* The shared Card, as the page's one column. */
.card {
  width: 100%;
  max-width: 420px;
  text-align: center;
}

.logo {
  display: block;
  width: 64px;
  height: 64px;
  margin: 0 auto var(--space-4);
}

.iconWrapper {
  margin-bottom: var(--space-4);
}

.icon {
  width: 48px;
  height: 48px;
  color: var(--accent);
}

.title {
  font-family: "Raleway", sans-serif;
  font-size: var(--text-3xl);
  font-weight: var(--font-semibold);
  color: var(--text);
  margin-bottom: var(--space-4);
}

.message {
  color: var(--text-muted);
  font-size: var(--text-md);
  margin-bottom: var(--space-1);
}

.email {
  color: var(--text);
  font-weight: var(--font-semibold);
  font-size: var(--text-lg);
  margin-bottom: var(--space-6);
}

.instructions {
  color: var(--text);
  font-size: var(--text-md);
  line-height: var(--leading-relaxed);
  margin-bottom: var(--space-6);
}

.tips {
  --kui-card-display: block;
  --kui-card-bg: var(--bg);
  --kui-card-radius: var(--radius-md);
  text-align: left;
  margin-bottom: var(--space-6);
}

.tipsTitle {
  font-family: "Raleway", sans-serif;
  font-size: var(--text-sm2);
  font-weight: var(--font-semibold);
  color: var(--text-muted);
  margin-bottom: var(--space-2);
}

.tipsList {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  color: var(--text-muted);
  font-size: var(--text-base);
}

.tipsList li::before {
  content: "\2022";
  color: var(--accent);
  margin-right: var(--space-2);
}

.supportLink {
  color: var(--link);
  text-decoration: none;
}

.supportLink:hover {
  text-decoration: underline;
}

.copyButton {
  margin-left: var(--space-2);
}

.backLink {
  color: var(--link);
  text-decoration: none;
  font-size: var(--text-base);
}

.backLink:hover {
  text-decoration: underline;
}
